import { Component, OnInit } from '@angular/core';
import {AdminSkillGroupsSelectionListService} from './admin-skill-groups-selection-list.service';

@Component({
  selector: 'app-admin-skill-groups-selection-list',
  templateUrl: './admin-skill-groups-selection-list.component.html',
  styleUrls: ['./admin-skill-groups-selection-list.component.css']
})
export class AdminSkillGroupsSelectionListComponent implements OnInit {

  constructor(public selectionListSv: AdminSkillGroupsSelectionListService) { }

  ngOnInit() {
  }

}
